import React from 'react'

import { observer } from 'mobx-react'
import Button from '../../../UniformComponents/Button'

const Savebar = observer(({ store }) => {
    const errors = store.featureFlagErrors(store.flag)
    const disabled = errors.length > 0 || !store.flag.name

    return (
        <div className="ff-savebar">
            <div className="ff-savebar__inner">
                <div className="ff-savebar__errors">
                    {errors.length > 0
                        ? errors.map((error) => (
                            <div className="ff-savebar__error" key={error.text}>
                                <i className="fal fa-triangle-exclamation" />
                                {error}
                            </div>
                        ))
                        : (
                            <div className="ff-savebar__ok">
                                <i className="fa-solid fa-circle-check" />
                                No configuration errors.
                            </div>
                        )}
                </div>
                <div className="ff-savebar__actions">
                    <Button
                        cssClass="regular"
                        label="Cancel"
                        variant="secondary"
                        onClick={store.backToIndex}
                    />
                    <Button
                        cssClass="regular"
                        label="Save changes"
                        variant="primary"
                        disabled={disabled}
                        onClick={store.flag.id ? store.updateFlag : store.createFlag}
                    />
                </div>
            </div>
        </div>
    )
})

export default Savebar
